export function initFlexVideo() {
    // Event delegation: works for dynamic content too
    document.addEventListener("click", (e) => {
        const btn = e.target.closest(".flex-video__overlay");
        if (!btn) return;

        const embed = btn.closest(".flex-video__embed");
        if (!embed) return;

        const media = btn.closest(".flex-video__media");
        const source = media ? media.getAttribute("data-video-source") : "";

        // FILE video: play the <video>
        if (source === "file") {
            const video = embed.querySelector("video");
            if (!video) return;

            embed.classList.add("is-playing");
            video.setAttribute("controls", "controls");

            // Attempt playback (may be blocked by browser policies; controls remain)
            video.play().catch(() => {});
            return;
        }

        // EMBED/URL: create iframe on click using data-src
        const src = embed.getAttribute("data-src");
        if (!src) return;

        // Avoid multiple iframes
        if (embed.querySelector("iframe")) {
            embed.classList.add("is-playing");
            return;
        }

        // Add autoplay=1 (works for most embed urls)
        const autoplaySrc = src + (src.includes("?") ? "&" : "?") + "autoplay=1";

        const iframe = document.createElement("iframe");
        iframe.src = autoplaySrc;
        iframe.loading = "lazy";
        iframe.frameBorder = "0";
        iframe.allow =
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
        iframe.allowFullscreen = true;

        embed.classList.add("is-playing");
        embed.appendChild(iframe);
    });
}
